var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDummyProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(12.433 35.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20046",
    "data-name": "Group 20046",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20054",
    "data-name": "Group 20054",
    transform: "translate(-177.433 -1088.865)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544",
    "data-name": "Ellipse 2544",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(165 1053)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(170 1058)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_1_2",
    "data-name": "user (1)",
    transform: "translate(180.901 1068.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20046-2",
    "data-name": "Group 20046",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31773",
    "data-name": "Path 31773",
    d: "M47.968,36.329a27.991,27.991,0,0,0-10.678-6.7,16.245,16.245,0,1,0-18.383,0A28.144,28.144,0,0,0,0,56.2H4.39a23.709,23.709,0,1,1,47.417,0H56.2A27.916,27.916,0,0,0,47.968,36.329ZM28.1,28.1A11.854,11.854,0,1,1,39.953,16.245,11.868,11.868,0,0,1,28.1,28.1Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfile);
export default __webpack_public_path__ + "static/media/dummyProfile.8f874b04846458369ae3388f0fd9f661.svg";
export { ForwardRef as ReactComponent };